import React, { Component } from 'react';
import { compose, withHandlers, withState, lifecycle } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import CardStatus from '../CardStatus';

import { COLORS, commonStyles } from '../../styles/styles';
import clsx from 'clsx';

import mail from '../../assets/closeEnvelope.svg';
import videoContent from '../../assets/icon_Video_W.svg';
import journalContent from '../../assets/icon_Journal_W.svg';
import pdfContent from '../../assets/icon_PDF_W.svg';
import surveyContent from '../../assets/icon_Survey_W.svg';
import thinktoolContent from '../../assets/icon_thinktool_W.svg';
import check from '../../assets/check.svg';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import iconVideo from '../../assets/icon_video.svg';
import iconPdf from '../../assets/icon_pdf.svg';
import iconPipe from '../../assets/icon_pipe.png';
import iconInfo from '../../assets/icon_info.png';
import iconComment from '../../assets/icon_comment.png';

import iconCalendarX from '../../assets/icon_calendarX_b.png';
import iconCalendar from '../../assets/icon_calendar_b.svg';
import iconZoom from '../../assets/icon_zoom_b.png';
import iconEye from '../../assets/icon_eye_w.png';
import iconSurvey from '../../assets/icon_assessment_b.png';
import iconThinktool from '../../assets/icon_thinktool.svg';
import iconJournal from '../../assets/icon_journal.svg';
import Collapse from '@material-ui/core/Collapse';
import CardContent from '@material-ui/core/CardContent';

import videoBg from '../../assets/bg_video.jpg';
import pdfBg from '../../assets/bg_document.jpg';
import surveyBg from '../../assets/bg_survey.jpg';
import thinktoolBg from '../../assets/bg_thinktool.jpg';
import journalBg from '../../assets/bg_journal.jpg';
import Button from '@material-ui/core/Button';
import * as moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import CardActions from '@material-ui/core/CardActions';

import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { IconContext } from "react-icons";
import { API_LINK } from '../../constants';

import axios from 'axios';


import ScaleLoader from 'react-spinners/ScaleLoader';
import { connect } from 'react-redux';



import {
  MDBBtn, 
  MDBCard, 
  MDBCardBody, 
  MDBRotatingCard,
  MDBCardImage,
  MDBCardTitle, 
  MDBCardText, 
  MDBRow, 
  MDBCol, 
  MDBIcon, 
  MDBBadge, 
  MDBContainer,
  MDBCollapseHeader,
  MDBCollapse
} from "mdbreact";
import placeHolder from '../../assets/placeholder.png'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { selectedContentId } from '../../redux/selectors';
import { convertTime, getClockTime } from '../../utils';
import { toggleResubmissionPopup, toggleSupplementaryPopup } from '../../redux/reducers/view';
import { selectAssessment, selectAssessmentContent, selectUserContent, submitMCQ, toggleExamComplete } from '../../redux/reducers/userProgramsFull';
import { assignmentRequestRequest, assignmentSubmitRequest, resetFetch } from '../../redux/reducers/assignmentRequest';
import { MdInfo } from "react-icons/md";
import { showMessageCenter } from '../../redux/reducers/messagesList';
import Countdown from 'react-countdown';
import { loginReducer } from '../../redux/reducers/login';
import { STORAGE_LINK } from '../../constants';
const API = `${API_LINK}api/submitExams/`
export const checkOverdue = dueDate => {
  // if(content.type!=='Assignments'){
   //  return true;
  // }else{
   
    return moment(dueDate).isBefore(moment().add(-1,'days'));
  //}
 
};


export const checkEnd = dueDate => {
  
  
    return moment(dueDate).isAfter(moment());
  
 
};

var att = 0


class ExamCard extends Component {
  state = { totalHeight:300,
    checkInterval:0
  
  }

 
  constructor(props){
    super(props)
    this.myDiv = React.createRef()
  }

  componentDidMount(){}

  flipCard() {
   
    try {
      
      this.setState({totalHeight:this.myDiv.current.clientHeight})
      this.props.flipIt(true);
    } catch (error) {
      
    }
  }

  flipCardAgain() {
   
    try {
      
      this.setState({totalHeight:this.myDiv.current.clientHeight})
      this.props.flipIt(false);
    } catch (error) {
      
    }
  
  }

  checkStart = (dueDate) => {
  
    if(moment(this.props.userProgramsFull.examTimeStart ? this.props.userProgramsFull.examTimeStart : dueDate).isBefore(moment())==true && this.props.examStarted==false){
      this.props.startExam(true)
    }
    return moment(this.props.userProgramsFull.examTimeStart ? this.props.userProgramsFull.examTimeStart : dueDate).isBefore(moment());

};

  checkEndTime = async() => {
    const endDate =
      this.props.userProgramsFull.examTimeEnd || this.props.content.end_date;
    if (checkEnd(endDate) === false) {
      this.props.endExam(true);
      this.props.toggleExamComplete(true);
      if (
        this.props.content.status != 'marking' &&
        this.props.content.status != 'not started' &&
        this.props.content.status != 'resubmission_request' &&
        this.props.content.status != 'submitted' &&
        this.props.content.status != 'completed'
      ) {
        var obj = {
          contentId: this.props.content.contentId,
          user_id: this.props.loginReducer.user.userId,
          survey_id: this.props.content.survey_id,
          rollout_id: this.props.content.rollout_id,
          module_id: this.props.content.module_id,
        };
        this.props.endExam(true);
      }

      clearInterval(this.state.checkInterval);
    }
  };

  closeExams=async()=>{
    
  }
  
  renderer = ({ days, hours, minutes, seconds, completed }) => {
 
    if (completed && this.props.content.status!='Marking' && this.props.examStarted==false) {
       this.props.startExam(true)
       this.setState({checkInterval:setInterval(this.checkEndTime, 1000)})
       return <div></div>;
     }else if(completed && this.props.content.status!='Marking'){
      return <div></div>;
     }else if(completed && this.props.content.status=='Marking'){
      return <div>Ended</div>;
     } else {
       if(days==0){
        if(this.props.examStarted ==true){
          this.props.startExam(false)
        }
        return <div><div style={{ width:"100%"}}>{hours}h {minutes}m {seconds}s</div></div>;
       }else{
        if(this.props.examStarted ==true){
          this.props.startExam(false)
        }
        return <div><div style={{ width:"100%"}}>{days} days {hours}h {minutes}m {seconds}s</div></div>;
       }
       
      
     }
   };
  
  render() {
    const { classes,
    isSelected,
    content,
    checkStart,
    isTransparent,
    backgroundImg,
    type,
    name,
    due_date,
    startDate,
    moduleName,
    handleExtensionRequest,
    handleResubRequest,
    handleExpandClick,
    handleOpen,
    handleSubmitExam,
    handleAlert,
    description,
    contentId,
    onThinkToolClick,
    status,
    messageCount,
    handleView,
    attempts,
    isExpanded,
    endDate,
    showAlert,
    toggleCollapse,
    collapseID, 
    flipped1, 
    flipCard,
    handleImageLoaded,
    showDeclineMessageState,
    showDeclineMessage,
    hideDeclineMessage,
    showDeclineExtensionState,
    showDeclineExtension,
    startExam,
    examOver,
    hideDeclineExtension,
    imageLoadedNow } = this.props;
    var newStatus = status
    if(newStatus=='submitted' || newStatus=='resubmission_request'){
      newStatus='marking'
    }
    return (
      //      
      //   {attempts.length>0 && 
      //     <CardActions className={`${classes.expandBar}`} >
      //         <Typography variant="headline" component="h1" className={classes.moduleName} style={{position:"absolute", left:5, marginBottom: 0}}>PAST ATTEMPTS</Typography>
      //       <IconButton
      //           style={{width: '0px', zIndex:'1000'}}
      //           className={clsx(classes.expand, {
      //             [classes.expandOpen]: isExpanded,
      //           })}
      //           onClick={event => handleExpandClick(event)}
      //           aria-expanded={isExpanded}
      //           aria-label="Show more"
      //         >
      //         <ExpandMoreIcon style={{color:'#fff', zIndex:'1000'}}/>
      //       </IconButton>
      //     </CardActions>
      //   }
      //   {attempts.length>0 && <Collapse in={isExpanded} timeout="auto" unmountOnExit>
      //       <CardContent  style={{padding:'0px'}}>
      //       <List style={{padding:'8px 0px 4px 8px', backgroundColor: '#e7e7e7'}}>
      //       {attempts.map(item => (
      //   <div
      //     key={item.attempt+Math.random()}
      //     style={{paddingBottom:10}}
      //   >
      //      {}
      //      {}
      //      <ListItem style={{paddingBottom: '10px'}}>
      //     {item.status=='Failed' ? <Typography style={{position:"absolute", left:5, }}>Attempt {item.attempt} - NYC</Typography> : <Typography style={{position:"absolute", left:5, }}>Attempt {item.attempt} - C</Typography>}
      //     <Typography style={{position:"absolute", right:50}}>{item.percentage}%</Typography>
      //       {item.status=='Failed' ?  <ListItemSecondaryAction><IconButton edge="end" aria-label="View" style={{color:'#CC0000'}}  onClick={() => handleView(content, item)}><Search />
      //         </IconButton>
      //       </ListItemSecondaryAction> : <ListItemSecondaryAction><IconButton edge="end" aria-label="View" style={{color:'#0aa632'}}  onClick={() => handleView(content, item)}><Search />
      //         </IconButton>
      //       </ListItemSecondaryAction>}
      //      </ListItem>
      //   </div>
      // ))}
      // </List>
      //       </CardContent>
      //     </Collapse>}
      //     {showAlert && <Dialog
      //       open={showAlert}
      //       onClose={handleAlert}
      //       aria-labelledby="alert-dialog-title"
      //       aria-describedby="alert-dialog-description"
      //     >
      //       <DialogTitle id="alert-dialog-title">{"Resubmissions"}</DialogTitle>
      //       <DialogContent>
      //         <DialogContentText id="alert-dialog-description">
      //         Please note that you are requested to pay for this resubmission attempt. Please refer to your learner support consultant for the fee and process to follow. You can view the resubmission request status in the ‘resubmissions for approval’ column. Your assessment will automatically become available in the “assessments available” column, with the new submission due date, once approved. 
      //         Thank you and good luck
      //         </DialogContentText>
      //       </DialogContent>
      //       <DialogActions>
      //         <Button onClick={()=>  handleResubRequest(content)} color="primary">
      //           Ok
      //         </Button>
      //         <Button onClick={handleAlert} color="primary" autoFocus>
      //           Cancel
      //         </Button>
      //       </DialogActions>
      //     </Dialog>}
      // </Card>
      <div style={{position:'relative'}}>
        <MDBCard cascade className='face front z-depth-2 mb-2 examCard' >
           
              <div style={{position:'relative'}}>
                <div className="compImg">
                  <img src={STORAGE_LINK+backgroundImg} className="z-depth-0 rounded-corners" style={{padding: 10, width:'100%'}} alt="" onLoad={handleImageLoaded} />
                </div>
                {content.resubmission_request && content.resubmission_request.comment && <IconContext.Provider value={{ color: "white", className: "global-class-name", size:'2em' }}>
                <div style={{position:'absolute', top:15, left:15, cursor:'pointer',filter: "drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.5));"}} onClick={()=>showDeclineMessage(content.resubmission_request.comment)}>
                <MdInfo/>
                </div>
                </IconContext.Provider>}

                {content.extension_request && content.extension_request.comment && content.extension_request.comment !='Free Extension Request' && <IconContext.Provider value={{ color: "white", className: "global-class-name", size:'2em' }}>
                <div style={{position:'absolute', top:15, left:15, cursor:'pointer', filter: "drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.5));"}} onClick={()=>showDeclineExtension(content.extension_request.comment)}>
                <MdInfo/>
                </div>
                </IconContext.Provider>}
                
                <div className="compPill">
                
                  {examOver==true && (newStatus=='ready' || newStatus=='in progress') ? <CardStatus className="white-text" status={'marking'}/> : status=='resubmission_request' ? <CardStatus className="white-text" status={'supplementary_request'}/> : <CardStatus className="white-text" status={status}/>}
                </div>
                

                {/* <div  style={{position:'absolute', bottom:40, zIndex:2}}>
                  <div className='xs-copy text-white uppercase-text text-left pt-3 pl-3'>
                    {moduleName}
                  </div>
                  <h6 className='text-white text-left pl-3 pb-2'>
                    {name}
                  </h6>
                </div>
                <div>
                  <img src={placeHolder} className="z-depth-0" style={{position:'sticky',top:0,left:0,padding: 0, width: '100%'}} alt=""/>
                  <img src={process.env.REACT_APP_MY_VAR+backgroundImg} className="z-depth-0" style={{position:'absolute',top:0,left:0,padding: 0, width: '100%'}} alt="" onLoad={handleImageLoaded} />          
                </div> */}
                
              </div>
             
              <MDBCardBody style={{position:'relative', minHeight: 220}}>
                <div className="compIcon">
                    <img src={iconSurvey} />
                </div>
                <div style={{fontSize: 12}}>
                  {moduleName}
                </div>
                <h6>
                  {name}
                </h6>

                {(attempts && attempts.length>0) && (((content.exam_type== "mcq" && content.status=="competent") || (content.exam_type== "mcq" && content.status=="not yet competent")) || content.exam_type=="freetext") &&
                          <div>
                          <MDBBtn className="assessmentBtn w-100" size="sm"  color="warning"  onClick={()=>handleView(content, content)}>
                           Show Results
                          </MDBBtn> 
                          </div>
                          }
                {( (status=='ready') && examOver==false && this.props.examStarted==true) && 
                <MDBBtn className="assessmentBtn w-100" size="sm" color="default"  onClick = {() => {handleSubmitExam(content)}}>
                  Submit Exam
                </MDBBtn>}

                {(this.props.examStarted==true && checkEnd(this.props.userProgramsFull.examTimeEnd ? this.props.userProgramsFull.examTimeEnd : endDate)==true && (status=='not started' || status=='in progress' || status=='ready') && examOver==false) && 
                <MDBBtn className="assessmentBtn w-100 btnMargin" color="yellow"  onClick = {() => {handleOpen(content)}}>
                  Open Exam
                </MDBBtn>}
                <div className='grey-bar grey lighten-2 pt-1 pl-2 pr-2' style={{height:34, bottom:0}}>
                  {/* <div className="xs-copy-popins" style={{width:'45%', float: 'left'}}>
                    <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round"  color="default-color text-white">{attempts.length>1 ? att=0 :  att = 2-attempts.length}</MDBBadge> Attempts
                  </div> */}
                  <img className="iconPipe" src={iconPipe} />

                  {(checkOverdue(this.props.userProgramsFull.examTimeEnd ? this.props.userProgramsFull.examTimeEnd : endDate) && (status=='ready' || status=='not started' || status=='in progress')) ? 
                    <div>
                      <div style={{width:'50%', float:'left', textAlign:'left'}}>
                      {!examOver && <div style={{display:'inline-block', float:'left', marginTop:7}} className="xs-copy-popins"> <Countdown date={this.props.userProgramsFull.examTimeStart ? this.props.userProgramsFull.examTimeStart : startDate} renderer={this.renderer} key={this.props.userProgramsFull.examTimeStart ? this.props.userProgramsFull.examTimeStart : startDate}/></div>}
                    </div> 
                    <div style={{width:'50%', float:'right', textAlign:'right'}}>
                      <div style={{display:'inline-block', float:'right', marginTop:3}} className="xs-copy-popins"><div>{convertTime(due_date)}</div><div style={{textAlign:'center', color:'#CC0000'}}>{getClockTime(this.props.userProgramsFull.examTimeStart ? this.props.userProgramsFull.examTimeStart : startDate)} - {getClockTime(this.props.userProgramsFull.examTimeEnd ? this.props.userProgramsFull.examTimeEnd : endDate)}</div></div>
                    </div> 
                    </div>
                   
                    : 
                    <div>
                    <div style={{width:'50%', float:'left', textAlign:'left'}}>
                    {!examOver && <div style={{display:'inline-block', float:'left', marginTop:7}} className="xs-copy-popins"><Countdown date={this.props.userProgramsFull.examTimeStart ? this.props.userProgramsFull.examTimeStart : startDate} renderer={this.renderer} key={this.props.userProgramsFull.examTimeStart ? this.props.userProgramsFull.examTimeStart : startDate}/></div>}
                  </div> 
                  <div style={{width:'50%', float:'right', textAlign:'right'}}>
                    <div style={{display:'inline-block', float:'right', marginTop:3}} className="xs-copy-popins"><div>{convertTime(due_date)}</div><div style={{textAlign:'center', color:'#CC0000'}}>{getClockTime(this.props.userProgramsFull.examTimeStart ? this.props.userProgramsFull.examTimeStart : startDate)} - {getClockTime(this.props.userProgramsFull.examTimeEnd ? this.props.userProgramsFull.examTimeEnd : endDate)}</div></div>
                  </div> 
                  </div>}
                </div>
                {/* <img style={{position:'absolute', right:20, bottom:26, height:25}} src={iconComment} /> */}
              </MDBCardBody>
              <ReactCSSTransitionGroup
                transitionName="fade"
                transitionEnterTimeout={500}
                transitionLeaveTimeout={500}>{imageLoadedNow && <div style={{backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
                <div style={{position:'absolute', top:"40%", width:'100%'}}>
              <ScaleLoader
               
               height={35}
               width={4}
               radius={2}
               margin='2px'
              color={COLORS.cornerstoneRed}
               loading={true}
             />
             </div>
              </div>}</ReactCSSTransitionGroup>

            </MDBCard>
        {}
        {showAlert && <Dialog
          open={showAlert}
          onClose={handleAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Resubmissions"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            Please note that you are requested to pay for this resubmission attempt. Please refer to your learner support consultant for the fee and process to follow. You can view the resubmission request status in the ‘resubmissions for approval’ column. Your assessment will automatically become available in the “assessments available” column, with the new submission due date, once approved. 
            Thank you and good luck
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>  {
                handleResubRequest(content);
                handleAlert(content);
              }
            } color="primary">
              Ok
            </Button>
            <Button onClick={handleAlert} color="primary" autoFocus>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>}
        {showDeclineMessageState && <Dialog
          open={showDeclineMessageState}
          onClose={hideDeclineMessage}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Comment"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            {content.resubmission_request.comment}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={hideDeclineMessage} color="primary" autoFocus>
              close
            </Button>
          </DialogActions>
        </Dialog>}
        {showDeclineExtensionState && <Dialog
          open={showDeclineExtensionState}
          onClose={hideDeclineExtension}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Comment"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            {content.extension_request.comment}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={hideDeclineExtension} color="primary" autoFocus>
              close
            </Button>
          </DialogActions>
        </Dialog>}
        <ReactCSSTransitionGroup
            transitionName="fade"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}>{((imageLoadedNow || this.props.contentReducer.fetchingItem==true) && contentId==this.props.currentContent) && <div onClick={(e)=>e.stopPropagation() } style={{pointerEvents:'all',backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
            <div style={{position:'absolute', top:"40%", width:'100%'}}>
          <ScaleLoader
           
           height={35}
           width={4}
           radius={2}
           margin='2px'
           color={COLORS.cornerstoneRed}
           loading={true}
         />
         </div>
          </div>}</ReactCSSTransitionGroup>
      </div>
    );
  }
      }

ExamCard.propTypes = {
  classes: PropTypes.instanceOf(Object),
  isSelected: PropTypes.bool,
  isTransparent: PropTypes.bool,
  backgroundImg: PropTypes.string,
  type: PropTypes.string,
  messageCount: PropTypes.number,
  name: PropTypes.string,
  handleExtensionRequest: PropTypes.func,
  handleView: PropTypes.func,
  handleSubmit: PropTypes.func,
  dueDate: PropTypes.string,
  startDate: PropTypes.string,
  description: PropTypes.string,
  status: PropTypes.string,
  contentId: PropTypes.number,
  onThinkToolClick: PropTypes.func,
};

const styles = () => ({
  ...commonStyles,
  expandBar:{
    backgroundColor: '#323232',
    height:'5px'
  },
  card: {
    borderRadius: 0,
    justifyContent: 'space-between',
    height: '100%',
    minHeight:280,
    backgroundSize: 'cover',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'visible',
    cursor: 'pointer',
    backgroundColor: COLORS.white,
    opacity: 1,
  },
  isTransparent: {
    opacity: 0.4,
  },
  selectedCard: {
    borderColor: COLORS.cornerstoneRed,
  },
  cardContent: {
    padding: 0,
    flex: 1,
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  defaultButton: {
    backgroundColor: COLORS.lightGrey,
    color: '#000',
    fontFamily: 'Gotham-Black',
    boxShadow: 'none',
    boxSizing: 'border-box',
    height: 30,
    width:'100%',
    borderRadius: 0,
    fontSize: 12,
    fontFamily: 'Roboto',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    '&:hover': {
      backgroundColor: COLORS.darkGrey,
      color: '#ffffff',
    },
    '&:active': {
      boxShadow: '0 1px 12px 7px rgba(0,0,0,0.5) inset',
    },
  },
  cardContentWrapper: {
    padding: 20,
    display: 'flex',
    flex: 2,
    flexDirection: 'column',
  },
  fileWrapper: {
    backgroundColor: '#161616',
    height:92
  },
  cardIcon:{
    position: 'absolute',
    bottom: 15,
    right: 15,
    height: 50
  },
  cardTitle: {
    fontFamily: 'Gotham-Black',
    color: COLORS.darkGrey,
    fontSize: 16,
    lineHeight: '20px',
    marginBottom: 10,
  },
  itemLeft: {
    flex: 4,
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative',
    marginTop: 28,
    '&:focus': {
      outline: 'none',
    },
  },
  assessmentDescription: {
    color: COLORS.white,
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 400,
    marginBottom: 10,
    maxHeight: 30,
    overflow: 'hidden',
    textShadow: '1px 1px 3px #000'
  },
  moduleName: {
    color: COLORS.white,
    fontFamily: 'Gotham-Black',
    fontSize: 10,
    lineHeight: '14px',
    fontWeight: 400,
    marginBottom: 10,
    maxHeight: 30,
    overflow: 'hidden',
  },
  cardBottom: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  doneWrapper: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
  checkboxChecked: {
    display: 'block',
    width: 28,
    height: 28,
    borderRadius: '50%',
    background: `url(${check}) 0 no-repeat`,
  },
});

const mapStateToProps = state => ({
  userProgramsFull: state.userProgramsFullReducer,
  contentReducer: state.contentListReducer,
  currentContent: selectedContentId(state),
  loginReducer:state.loginReducer
});

const mapDispatchToProps = dispatch => ({
  toggleResubmissionPopup: bool => dispatch(toggleResubmissionPopup(bool)),
  selectAssessment: surveyId => dispatch(selectAssessment(surveyId)),
  selectAssessmentContent: obj => dispatch(selectAssessmentContent(obj)),
  resetFetch: () => dispatch(resetFetch()),
  toggleExamComplete:bool => dispatch(toggleExamComplete(bool)),
  selectAssessment: surveyId => dispatch(selectAssessment(surveyId)),
  submitMCQRequest: value => dispatch(submitMCQ(value)),
  submitExamRequest: value => dispatch(assignmentSubmitRequest(value)),
  selectUserContent: contentId => dispatch(selectUserContent(contentId)),
  toggleSupplementaryPopup: bool => dispatch(toggleSupplementaryPopup(bool)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('isShowPopup', 'togglePopup', false),
  withState('isExpanded', 'toggleExpanded', false),
  withState('showAlert', 'toggleShowAlert', false),
  withState('showDeclineMessageState', 'toggleDeclineMessage', false),
  withState('showDeclineExtensionState', 'toggleDeclineExtension', false),
  withState('examStarted', 'startExam', false),
  withState('examOver', 'endExam', false),
  withState('flipped1', 'flipIt', false),
  withState('imageLoadedNow', 'toggleImageLoaded', true),
  withHandlers({
    handlePopupToggle: props => (item, closed, video) => {
      const { isShowPopup, xapiRequest, getUserComponent, selectedContent, selectedContent: { type: contentType  }, saveTimeTaken, addComponentStatusRequest }= props;



      //xapiRequest({ xapiType: `${xapiType}`});
      if (isShowPopup) {
        //getUserComponent()
      }



      if (((contentType!='Assignments'|| contentType=== 'Assessment Builder' || contentType=== 'Exam Builder') && contentType!='Survey' && contentType!='Webinar' && contentType!='WSR Assessments') || (video==true && contentType=='Webinar')) {
      //   saveStatus(STATUSES.completed.value);
      //  // saveTimeTaken(Math.round((Date.now() - startTimePdf) / 1000));
      //   addComponentStatusRequest();
      }else{
        //getUserComponent();
      }
      if(closed==true){
        var itemToRemove
        var tmp = props.popups;
        tmp.splice(props.view.windowDeleteIndex,1)
        props.setPopups([]);
        //}

        //props.togglePopup(!isShowPopup);
      }else{
        
        var tmp = props.popups;
        tmp.push(item);
        props.setPopups(tmp);
        //props.togglePopup(!isShowPopup);

      }
    },
    onThinkToolClick: props => (event, contentId) => {
      const { openMessages, selectedContentHandler } = props;
      event.stopPropagation();
      openMessages(true);
      selectedContentHandler(contentId);
    },
    
    flipCard: props => () => {
      const { isExpanded, flipped1 } = props;
      props.flipIt(!flipped1);
    },
    handleAlert: props => (item) => {
      props.selectAssessment(item.survey_id)
      props.selectAssessmentContent(item)
      props.resetFetch()
      props.toggleResubmissionPopup(true)
    },
    handleImageLoaded: props => () => {
      props.toggleImageLoaded(false)
    },
    showDeclineMessage: props => () => {
      props.toggleDeclineMessage(true)
    },
    hideDeclineMessage: props => () => {
      props.toggleDeclineMessage(false)
    },
    showDeclineExtension: props => () => {
      props.toggleDeclineExtension(true)
    },
    hideDeclineExtension: props => () => {
      props.toggleDeclineExtension(false)
    }
  }),
  withStyles(styles),
)(ExamCard);
